import { FormControl, FormField, FormItem, FormLabel, FormMessage, Helptext, Input } from "@/shared/components";
import { cn } from "@/shared/utils";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";

interface InputFormFieldProps<T extends FieldValues> {
    form: UseFormReturn<T>;
    label?: string;
    name: FieldPath<T>;
    defaultValue?: string;
    className?: string;
    inputClassName?: string;
    labelClassName?: string;
    readOnly?: boolean;
    helptext?: string;
}

export function FormFieldInputTime<T extends FieldValues>({
    form,
    label,
    name,
    defaultValue,
    className,
    inputClassName,
    labelClassName,
    readOnly,
    helptext,
}: Readonly<InputFormFieldProps<T>>) {
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    {label && <FormLabel className={labelClassName}>{label}</FormLabel>}
                    <FormControl>
                        {readOnly ? (
                            <span className="text-content-placeholder w-full px-3 py-2">{field.value || "Onbekend"}</span>
                        ) : (
                            <Input
                                type="time"
                                step="60000"
                                defaultValue={defaultValue}
                                className={cn(
                                    "w-bg-background w-full appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none",
                                    inputClassName
                                )}
                                {...field}
                            />
                        )}
                    </FormControl>
                    <div>
                        {helptext && <Helptext>{helptext}</Helptext>}
                        <FormMessage />
                    </div>
                </FormItem>
            )}
        />
    );
}
